/* type TextInputProps = {
    type?: string
    name: string
    value?: string | number
    label?: string
    placeholder?: string
    className?: string
    description?: string | ReactElement
    inputClassName?: string
    handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    handleBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void
    pattern?: string
    disabled?: boolean
} */

// @todo replace all this shit
export const TextInput = ({
    name,
    type = 'text',
    value,
    label = '',
    placeholder = '',
    description,
    className = '',
    labelClassName = '',
    inputClassName = '',
    overrideInputClassName = false,
    handleChange,
    handleBlur,
    pattern,
    disabled = false,
    ...props
}) => {
    
    return (
        <div className={`${className}`}>
            {label && (
                <label className={labelClassName} data-toggle="tooltip" data-placement="top" title={label}>
                    {label}
                </label>
            )}
            {description}
            {
                <input
                    type={type}
                    value={value}
                    className={overrideInputClassName ? inputClassName : `${inputClassName} input w-full`}
                    name={name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder={placeholder}
                    pattern={pattern}
                    disabled={disabled}
                    {...props} />
            }
        </div>
    )
}
